// components/Dialog/Dialog.tsx
import { ReactNode } from 'react';
import styles from './dialog.module.scss';
import { Modal } from './modal';

interface Props {
    title: string;
    children: ReactNode;
    onClose: () => void;
    large?: boolean;
}

export function Dialog({
    title,
    children,
    onClose,
    large = false,
}: Props) {
    return (
        <Modal onClose={onClose}>
            <div className={styles.outer}>
                <div className={`${styles.inner} ${large ? styles.large : ''}`}>
                    <div className={styles.header}>
                        <h2 className={styles.title}>{title}</h2>

                        <button
                            className={styles.close}
                            onClick={onClose}
                            aria-label='Close dialog'
                        >
                            ×
                        </button>
                    </div>

                    <div className={styles.content}>
                        {children}
                    </div>
                </div>
            </div>
        </Modal>
    );
}
